// Copyright (c) 2017 Comsearch, Inc., All rights reserved

import { SubmitErrors } from 'components/Form'
import React from 'react'
import { array, bool, func, string } from 'prop-types'
import { reduxForm } from 'redux-form'
import { pathDatabaseSearchValidate } from 'validators/databaseSearches'

import {
  OuterImport,
  Search,
} from './components'

import {
  AdvancedSearchWrapper,
  Pagination,
} from '../common'

const {
  asyncValidate,
  validate,
} = pathDatabaseSearchValidate

const Form = props => {
  const {
    change,
    customImportHandler,
    error,
    form,
    hasResults,
    highlightRows,
    highlightedRows,
  } = props

  return (
    <form
      className={'path-database-search-form heading-font'}
      id={form}>
      {
        highlightRows &&
        <OuterImport
          customImportHandler={customImportHandler}
          highlightRows={highlightRows}
          highlightedRows={highlightedRows}
          idRoot={form}
          sourceForm={form} />
      }
      <SubmitErrors
        error={error}
        idRoot={form}
        sourceForm={form} />
      <AdvancedSearchWrapper
        AdvancedSearch={Search}
        change={change}
        customImportHandler={customImportHandler}
        hasResults={hasResults}
        highlightRows={highlightRows}
        highlightedRows={highlightedRows}
        idRoot={`${form}-`}
        sourceForm={form} />
      <Pagination
        idRoot={`${form}-`}
        sourceForm={form} />
    </form>
  )
}

Form.propTypes = {
  change: func.isRequired,
  customImportHandler: func.isRequired,
  form: string.isRequired,
  handleSubmit: func.isRequired,
  hasResults: bool.isRequired,
  highlightRows: bool,
  highlightedRows: array.isRequired,
  error: string,
}

export default reduxForm({
  asyncBlurFields: [
    'antennaCode',
    'radioCode',
  ],
  asyncValidate,
  validate,
})(Form)
